import { Typography, Skeleton } from 'fronton-react';
import {
  gallery__container,
  gallery,
  gallery_paddings,
  gallery__header,
  gallery__container_large,
} from 'pages/root-gallery/styles';
import { useGAElementBlock } from 'common/analytics/use-ga-element-block';
import { useAppSelector } from 'common/hooks';
import { projectsSlice } from 'app-entities/projects/projects-slice';
import { ProjectCard } from 'pages/root-gallery/project-card/project-card';
import { dataFromParentMicrofrontSlice } from 'store/data-from-parent-microfront-slice';
import { useCombinePromoView } from 'common/analytics/use-combine-promo-view';
import { LoadMoreButton } from './load-more-button';

export const RootGallery = () => {
  const elementBlock = useGAElementBlock();
  const projects = useAppSelector(projectsSlice.selectors.selectProjects);
  const isProjectsLoading = useAppSelector(projectsSlice.selectors.selectIsLoading);
  const isFirstLoadError = useAppSelector(projectsSlice.selectors.selectFirstLoadIsError);
  const title = useAppSelector(dataFromParentMicrofrontSlice.selectors.selectGalleryTitle);
  const subtitle = useAppSelector(dataFromParentMicrofrontSlice.selectors.selectGallerySubtitle);
  const isLargeGallery = useAppSelector(dataFromParentMicrofrontSlice.selectors.selectIsLargeView);
  const isKZRegion = useAppSelector(dataFromParentMicrofrontSlice.selectors.selectIsKZRegion);
  const isPaddingsEnabled = useAppSelector(dataFromParentMicrofrontSlice.selectors.selectIsPaddingsEnabled);
  const analyticsName = useAppSelector(dataFromParentMicrofrontSlice.selectors.selectAnalyticsName);

  const sendCombinedViewEvent = useCombinePromoView({ elementBlock: analyticsName || elementBlock });

  if (isKZRegion) {
    return null;
  }

  if (isFirstLoadError) {
    return null;
  }

  if (projects.length === 0) {
    return null;
  }

  return (
    <div
      data-testid="inspiration-gallery-root-gallery"
      className={`${gallery} ${isPaddingsEnabled ? gallery_paddings : ''}`}>
      <div className={gallery__header}>
        <Typography variant="h2" color="text-primary" data-testid="inspiration-gallery-title">
          {title}
        </Typography>
        <Typography
          variant="m"
          size="body_long"
          color="text-primary"
          data-testid="inspiration-gallery-subtitle">
          {subtitle}
        </Typography>
      </div>

      <div
        data-testid="inspiration-gallery-projects-container"
        className={`${gallery__container} ${isLargeGallery ? gallery__container_large : ''}`}>
        {projects.map((item, index) => (
          <ProjectCard
            isLargeGallery={isLargeGallery}
            projectTransliteration={item.projectTransliteration}
            projectLibraryName={item.projectLibraryName}
            mainPictureLinkInWebPFormat={item.mainPictureLinkInWebPFormat}
            mainPictureLink={item.mainPictureLink}
            projectMinPrice={item.projectMinPrice}
            key={item.projectLibraryId}
            elementBlock={analyticsName || elementBlock}
            sendCombinedViewEvent={sendCombinedViewEvent}
            position={index + 1}
          />
        ))}
        <Skeleton variant="control" showLoading={isProjectsLoading} width="100%" height="300px" />
        <Skeleton variant="control" showLoading={isProjectsLoading} width="100%" height="300px" />
        <Skeleton variant="control" showLoading={isProjectsLoading} width="100%" height="300px" />
        <Skeleton variant="control" showLoading={isProjectsLoading} width="100%" height="300px" />
        <Skeleton variant="control" showLoading={isProjectsLoading} width="100%" height="300px" />
        <Skeleton variant="control" showLoading={isProjectsLoading} width="100%" height="300px" />
        <Skeleton variant="control" showLoading={isProjectsLoading} width="100%" height="300px" />
        <Skeleton variant="control" showLoading={isProjectsLoading} width="100%" height="300px" />
      </div>
      <LoadMoreButton />
    </div>
  );
};
